import { Col, message, PageHeader, Row, Select, Space, Spin, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  TableItem,
  SwitchItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { descargarExcel, descargarPdf } from "./exportarInsumosYEquivalencias";
import AyudaEquivalencia from "../../../../Components/AyudaEquivalencia";

const { Option } = Select;
const { TabPane } = Tabs;

const COLOR_INSUMO = "#00BFD6";
const COLOR_EQUIVALENCIA = "#FAAD14";
const COLOR_NEUTRO = "#595959";

const ETIQUETA_TIPO = { 1: "Solo de venta", 2: "Solo de compra", 3: "Solo inventariables" };
const ETIQUETA_MOSTRAR = { 2: "Solo insumos con equivalencias", 3: "Solo insumos sin equivalencias" };

const sorterTexto = (campo) => (a, b) =>
  (a[campo] || "").toString().localeCompare((b[campo] || "").toString());

/** El cuadrito de color de la leyenda. */
const Muestra = ({ color, children }) => (
  <span style={{ marginRight: 16, whiteSpace: "nowrap" }}>
    <span
      style={{
        display: "inline-block",
        width: 12,
        height: 12,
        borderRadius: 2,
        marginRight: 6,
        verticalAlign: "middle",
        backgroundColor: color,
      }}
    />
    {children}
  </span>
);

/**
 * Reporte Insumos Y Equivalencias.
 *
 * El catalogo de insumos con sus equivalencias (las presentaciones de venta de
 * `Insumo.equivalencias[]`) como renglones hijos: el insumo va en turquesa y
 * sus equivalencias en ambar, y el tono alterna de un insumo al siguiente para
 * que se vea donde empieza cada bloque. El mismo color viaja al Excel y al PDF.
 *
 * El Factor se muestra pelon, a proposito: los rotulos de la pantalla de
 * captura describen el factor al reves que el codigo, asi que una frase tipo
 * "1 CAJA = 12 PZA" armada desde la descripcion puede salir invertida. El costo
 * de la equivalencia si es `costo del insumo / factor`, que es la convencion de
 * todo el backend.
 */
class ReporteInsumosYEquivalencias extends Component {
  state = {
    loading: false,
    datos: [],
    listasPrecios: [],
    resumen: {},
    consultado: false,
    filtros: {},
    objetoFamilias: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "familias/selectFamilias",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoFamilias: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      })
      .catch(() => {
        message.error("Error de conexion");
      });
    this.consultarReporte();
  }

  consultarReporte(values = {}) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteInsumosYEquivalencias",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            consultado: true,
            datos: res.data.datos || [],
            listasPrecios: res.data.listasPrecios || [],
            resumen: res.data.resumen || {},
            filtros: values,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error de conexion");
        this.setState({ loading: false });
      });
  }

  descripcionFiltros() {
    const filtros = this.state.filtros || {};
    const partes = [];
    if (filtros.familias?.length > 0) {
      partes.push(`${filtros.familias.length} familia(s)`);
    } else {
      partes.push("Todas las familias");
    }
    if (filtros.soloActivos) partes.push("Solo insumos activos");
    if (ETIQUETA_TIPO[filtros.tipo]) partes.push(ETIQUETA_TIPO[filtros.tipo]);
    if (ETIQUETA_MOSTRAR[filtros.mostrar]) partes.push(ETIQUETA_MOSTRAR[filtros.mostrar]);
    return partes.join(" - ");
  }

  parametrosExportacion() {
    return {
      datos: this.state.datos,
      listasPrecios: this.state.listasPrecios,
      resumen: this.state.resumen,
      empresaNombre: this.props.empresa,
      descripcionFiltros: this.descripcionFiltros(),
    };
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const basesPorInsumoId = {};
    this.state.datos.forEach((d) => {
      if (d.tipo === "insumo") basesPorInsumoId[d.insumoId] = d;
    });

    const columns = [
      {
        title: "Tipo",
        dataIndex: "tipo",
        key: "tipo",
        width: "8%",
        // En el insumo se anota entre parentesis cuantas presentaciones cuelgan
        // de el, que es justo lo que este reporte viene a contestar.
        render: (value, record) => (
          <span
            style={{
              color: value === "insumo" ? "#00505C" : "#874D00",
              fontWeight: value === "insumo" ? 600 : 400,
            }}
          >
            {value === "insumo"
              ? `Insumo${record.numeroEquivalencias ? ` (${record.numeroEquivalencias})` : ""}`
              : "Equivalencia"}
          </span>
        ),
      },
      {
        title: "Codigo",
        dataIndex: "codigo",
        key: "codigo",
        width: "6%",
        sorter: (a, b) => (a.codigo || 0) - (b.codigo || 0),
        buscar: "codigo",
      },
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        width: "8%",
        buscar: "clave",
        ellipsis: true,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcion",
        key: "descripcion",
        width: "24%",
        sorter: sorterTexto("descripcion"),
        buscar: ["descripcion", "codigo", "clave"],
        ellipsis: true,
        // La sangria deja ver el anidamiento aun impreso en blanco y negro.
        render: (value, record) => (
          <span style={{ paddingLeft: record.tipo === "insumo" ? 0 : 18 }}>{value}</span>
        ),
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        width: "12%",
        sorter: sorterTexto("familia"),
        buscar: "familia",
        ellipsis: true,
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        width: "8%",
        ellipsis: true,
      },
      {
        title: "Factor",
        dataIndex: "factor",
        key: "factor",
        width: "6%",
        align: "right",
        render: (value, record) => {
          if (!value) return "";
          const base = basesPorInsumoId[record.insumoId];
          return (
            <span>
              {`x${value}`}
              <AyudaEquivalencia
                nombreBase={base?.descripcion}
                cantidadBase={value}
                nombrePresentacion={record.descripcion}
                cantidadPresentacion={1}
              />
            </span>
          );
        },
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        width: "9%",
        align: "right",
        render: (value) => (value === null || value === undefined ? "" : dineroDisabledMask(value)),
      },
      ...this.state.listasPrecios.map((lista) => ({
        title: lista.nombre,
        dataIndex: lista.precioId,
        key: lista.precioId,
        width: "9%",
        align: "right",
        render: (value, record) => {
          const precio = (record.precios || {})[lista.precioId];
          return precio === null || precio === undefined ? "" : dineroDisabledMask(precio);
        },
      })),
    ];

    const resumen = this.state.resumen || {};

    return (
      <Form
        name="reporteInsumosYEquivalencias"
        onFinish={this.consultarReporte.bind(this)}
        onFinishFailed={this.onFinishFailed}
      >
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            "Reporte Insumos Y Equivalencias" +
            (this.state.consultado
              ? `: ${resumen.insumos || 0} insumos, ${resumen.equivalencias || 0} equivalencias`
              : "")
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", justifyContent: "right" }}>
              <Space>
                {this.state.datos.length > 0 && (
                  <ButtonItem
                    blanco
                    onClick={() => descargarExcel(this.parametrosExportacion())}
                    icon={<FileExcelOutlined />}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Descargar Excel
                  </ButtonItem>
                )}
                {this.state.datos.length > 0 && (
                  <ButtonItem
                    blanco
                    onClick={() => descargarPdf(this.parametrosExportacion())}
                    icon={<FilePdfOutlined />}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Descargar PDF
                  </ButtonItem>
                )}
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Consultar
                </ButtonItem>
              </Space>
            </div>
          }
        />
        <Spin spinning={this.state.loading}>
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 5,
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Tabs
              style={{ margin: 0 }}
              tabBarExtraContent={{
                left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
              }}
            >
              <TabPane tabKey="1" key="1" forceRender tab="Catalogo">
                <Row>
                  <Col span={10}>
                    <FormItem label="Familias" name="familias" margin>
                      <SelectItem width="90%" placeholder="Todas" mode="multiple">
                        {this.state.objetoFamilias}
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={7}>
                    <FormItem label="Tipo" name="tipo" margin initialValue={0}>
                      <SelectItem width="90%" placeholder="Tipo">
                        <Option value={0}>Todos</Option>
                        <Option value={1}>De venta</Option>
                        <Option value={2}>De compra</Option>
                        <Option value={3}>Inventariables</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={7}>
                    <FormItem
                      label="Solo activos"
                      name="soloActivos"
                      valuePropName="checked"
                      margin
                      tooltip="Deja fuera los insumos deshabilitados del catalogo."
                    >
                      <SwitchItem />
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabKey="2" key="2" forceRender tab="Equivalencias">
                <Row>
                  <Col span={10}>
                    <FormItem
                      label="Mostrar"
                      name="mostrar"
                      margin
                      initialValue={1}
                      tooltip="Una equivalencia es una presentacion de venta del mismo insumo (caja, paquete, medio litro) con su propia unidad y sus propias listas de precios."
                    >
                      <SelectItem width="90%" placeholder="Mostrar">
                        <Option value={1}>Todos los insumos</Option>
                        <Option value={2}>Solo los que tienen equivalencias</Option>
                        <Option value={3}>Solo los que no tienen equivalencias</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </div>
          <div style={{ height: 10 }} />
          <div style={{ backgroundColor: "white", padding: 20, borderRadius: 5 }}>
            <p style={{ color: COLOR_NEUTRO, marginBottom: 10 }}>
              <Muestra color={COLOR_INSUMO}>Insumo</Muestra>
              <Muestra color={COLOR_EQUIVALENCIA}>Equivalencia</Muestra>
              {this.state.consultado &&
                `${resumen.insumosConEquivalencias || 0} de ${resumen.insumos || 0} insumos tienen equivalencias`}
            </p>
            <TableItem
              size="small"
              dataSource={this.state.datos}
              columns={columns}
              rowKey={(value) => value.filaId}
              defaultPageSize={200}
              rowClassName={(record) =>
                `fila-${record.tipo === "insumo" ? "insumo" : "equiv"}-${record.bloque ? "b" : "a"}-cat`
              }
            />
          </div>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresa: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteInsumosYEquivalencias);
